import { CourseInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface'

export function getSortedCourseList(items: CourseInterface[]) {
  return items.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    }
    if (a.name > b.name) {
      return 1
    }
    return 0
  })
}
